import React, { useContext, useState } from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

import { DashboardContext } from '../DashboardProvider';
import { AddIssueTypeButtonView } from './AddIssueTypeButton.view';

export const AddIssueTypeButton = () => {
  const { isProjectAdmin } = useContext(DashboardContext);
  const [showNoPermissionModal, setShowNoPermissionModal] = useState(false);

  const goToSettings = () => {
    if (isProjectAdmin) {
      window.open(
        StorageOfUniqueServices.get('URLService').getSettingsUrl(),
        '_blank'
      );
    } else {
      setShowNoPermissionModal(true);
    }
  };

  return (
    <AddIssueTypeButtonView
      handleClick={() => goToSettings()}
      showNoPermissionModal={showNoPermissionModal}
      handleCloseModal={() => setShowNoPermissionModal(false)}
    />
  );
};
